<style scoped>
textarea {
  border: 1px solid black;
  background: green;
  color: white;
  padding: 10px;
  width: 500px;
  height: 300px;
}
.registration-time.green {
    color: rgb(46, 128, 46);
}
.registration-time.red {
    color: rgb(253, 85, 85);
}
</style>


<template>
<div class="user_table_row">
    <div class="user_table_cell">
        {{user.id_user}}
    </div>
    <div class="user_table_cell name" @click="goTo">{{user.email}}</div>
    <div class="user_table_cell registration-time" :class="user.active ? 'green' : 'red'">{{regTime}}</div>
    <div class="user_table_cell connection-time">{{connectionTime}}</div>
    <div class="user_table_cell connection_status">
        <div class="icon globe" :class="user.connection_status ? 'connected' : ''"></div>
    </div>
    <div class="user_table_cell comment-icon-block">
        <div class="icon" @click="showCommentModal" :class="user.comment ? 'filled-comment' : 'comment'"></div>
    </div>
    <div class="user_table_cell lock-icon-block">
        <div class="icon lock" @click="showLockModal" :class="user.block_status ? 'is-lock' : ''"></div>
    </div>
    <div class="user_table_cell mail-icon-block">
        <div class="icon mail-icon" @click="showMailModal"></div>
    </div>
    <div class="user_table_cell">
        <b-btn class="icon cancel" :id="nameDelButtton" @click="del_popover = !del_popover"></b-btn>
    </div>
    <b-popover :show.sync="del_popover" :target="nameDelButtton" title="Удалить этого пользователя" class="group-del-popover">
        <button type="button" class="btn btn-outline-danger" @click="deleteUser">Да</button>
        <button type="button" @click="onCloseDelPopover" class="btn btn-outline-info">Нет</button>
    </b-popover>
    <b-modal size="lg" ref="commentModal" hide-footer v-model="show_comment_modal">
      <div class="d-block text-center">
        <h3>{{titleCommentModal}}</h3>
        <textarea-comment-component 
            v-if="show_comment_modal"
            v-on:hideModal="hideCommentModal()" :id_user=user.id_user></textarea-comment-component>
      </div>
    </b-modal>
    <b-modal size="lg" ref="lockModal" hide-footer v-model="show_lock_modal">
      <div class="d-block text-center">
        <h3>{{titleLockModal}}</h3>
        <faucets-component v-if="show_lock_modal" :id_user=user.id_user></faucets-component>
      </div>
    </b-modal>
    <b-modal size="lg" ref="mailModal" hide-footer v-model="show_mail_modal">
      <div class="d-block text-center">
        <h3>{{titleMailModal}}</h3>
        <mails-component v-if="show_mail_modal" :id_user=user.id_user v-on:hideModal="hideMailModal()"></mails-component>
      </div>
    </b-modal>
</div>
</template>

<script>
import config from '@/config.js'
import axios from 'axios'
import textareaComment from './user-comments.vue'
import faucetsComponent from './user-faucets.vue'
import mailsComponent from './user-mails.vue'

export default {
    name: 'user-row',
    props: {
        group: Object
    },
    components: {
        'textarea-comment-component': textareaComment,
        'faucets-component': faucetsComponent,
        'mails-component': mailsComponent
    },
    data() {
        return {
            del_popover: false,
            show_comment_modal: false,
            show_lock_modal: false,
            show_mail_modal: false
        }
    },
    props: ['user'],
    methods: {
        showCommentModal() {
            this.$refs.commentModal.show()
        },
        hideCommentModal() {
            this.$refs.commentModal.hide()
        },
        showLockModal() {
            this.$refs.lockModal.show()
        },
        hideLockModal() {
            this.$refs.lockModal.hide()
        },
        showMailModal() {
            this.$refs.mailModal.show()
        },
        hideMailModal() {
            this.$refs.mailModal.hide()
        },
        goTo: function () {
            if (!!localStorage.token) {
                var vue_obj = this
                var post_data = new FormData()
                post_data.set('token', localStorage.token)
                post_data.set('id_user', this.user.id_user)
                axios({
                        method: 'POST',
                        url: config.API_HOST + '/aquazor-users/get_token',
                        data: post_data
                    })
                    .then(function (response) {
                        if (!!response.data.user_token) {
                            window.open(config.USER_HOST + "/set-local-token/" + response.data.user_token, "_blank");
                        }
                    })
                    .catch(function (error) {

                    })
            }
        },
        deleteUser: function () {
            if (!!localStorage.token) {
                var post_data = new FormData()
                post_data.set('token', localStorage.token)
                post_data.set('id_user', this.user.id_user)
                var vue_obj = this
                axios({
                        method: 'POST',
                        url: config.API_HOST + '/aquazor-users/delete_user',
                        data: post_data
                    })
                    .then(function (response) {
                        vue_obj.$emit('deleteRow')
                    })
                    .catch(function (error) {
                        console.log(error)
                    })
            }
        },
        onCloseDelPopover() {
            this.del_popover = false
        },
    },
    computed: {
        regTime: function () {
            var date = new Date
            date.setTime(this.user.registration_time * 1000)
            return zero_in_start(date.getDate()) + '-' + zero_in_start(date.getMonth() + 1) + '-' + date.getFullYear() + ' ' +
                date.getHours() + ':' + zero_in_start(date.getMinutes()) + ':' + zero_in_start(date.getSeconds())
        },
        connectionTime: function () {
            if (this.user.connection_time) {
                var date = new Date
                date.setTime(this.user.connection_time * 1000)
                return zero_in_start(date.getDate()) + '-' + zero_in_start(date.getMonth() + 1) + '-' + date.getFullYear() + ' ' +
                    date.getHours() + ':' + zero_in_start(date.getMinutes()) + ':' + zero_in_start(date.getSeconds())
            } else {
                return '-'
            }
        },
        nameDelButtton: function () {
            return 'delUser-' + this.user.id_user
        },
        titleCommentModal: function () {
            return "Коментарии к пользователю " + this.user.email
        },
        titleLockModal: function () {
            return "Блокировка кранов пользователя " + this.user.email
        },
        titleMailModal: function () {
            return "Уведомления " + this.user.email
        }
    }
}

function zero_in_start(number) {
    if (number >= 0 && number <= 9) {
        return '0' + number
    } else {
        return number
    }
}
</script>



// WEBPACK FOOTER //
// src/components/elements/user_row.vue